import { API_ENDPOINTS } from "@/api/services/attendanceMaster/apiEndpoints";
import { baseApi } from "@/utils/baseApi";


export const shiftMasterApi = baseApi.injectEndpoints({


    endpoints: (builder) => ({

        fetchShiftType: builder.query({
            query: () => ({
                url: API_ENDPOINTS.SHIFT_MASTER.FETCH_SHIFT_TYPE(),
                method: "GET",
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [{ type: "shiftType", id: "LIST" }]
                    : [{ type: "shiftType", id: "LIST" }],

        }),

        fetchShiftMaster: builder.query({
            query: () => ({
                url: API_ENDPOINTS.SHIFT_MASTER.FETCH_SHIFT_MASTER,
                method: "GET"
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [{ type: "ShiftMaster", id: "LIST" }]
                    : [{ type: "ShiftMaster", id: "LIST" }],



        }),

        postShiftMaster: builder.mutation({
            query: ({ formData }) => ({
                url: API_ENDPOINTS.SHIFT_MASTER.ADD_SHIFT_MASTER(),
                method: "POST",
                body: formData
            }),
            invalidatesTags: [{ type: "ShiftMaster", id: "LIST" }],
        }),

        updateShiftMaster: builder.mutation({
            query: ({ formData, id }) => ({
                url: API_ENDPOINTS.SHIFT_MASTER.UPDATE_SHIFT_MASTER(id),
                method: "PUT",
                body: formData
            }),
            invalidatesTags: [{ type: "ShiftMaster", id: "LIST" }],
        }),

        // sample excel
        getShiftMasterSample: builder.query({
            query: () => ({
                url: API_ENDPOINTS.SHIFT_MASTER.GET_SHIFT_MASTER_SAMPLE(),
                responseHandler: async (response) => response.blob(), // Ensure Blob conversion
            }),
            providesTags: ["ShiftMaster"],
        }),

        deleteShift: builder.mutation({
            query: ({ id }) => ({
                url: API_ENDPOINTS.SHIFT_MASTER.DELETE_SHIFT(id),
                method: "DELETE",
            }),
            invalidatesTags: ["ShiftMaster"],
        }),

        shiftBulkUpload: builder.mutation({
            query: ({ formData }) => {
                return {
                    url: API_ENDPOINTS.SHIFT_MASTER.BULK_UPLOAD(),
                    method: "POST",
                    body: formData,
                    responseHandler: async (response) => {
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.log(errorData);
                            return errorData;
                        }
                        return response.blob();
                    },
                };
            },
        }),




    }),
})

export const { useFetchShiftTypeQuery, useFetchShiftMasterQuery, usePostShiftMasterMutation, useUpdateShiftMasterMutation,
    useGetShiftMasterSampleQuery, useDeleteShiftMutation, useShiftBulkUploadMutation } = shiftMasterApi;